module.exports = "<div>\r\n  <!-- <zxing-scanner #scanner (codeResult)=\"onCodeResult($event)\" formats]=\"['QR_CODE']\"></zxing-scanner> -->\r\n</div>"